import type React from 'react'

export interface RowsTableColumn {
  header: string
  className?: string
}

/** A compact table in the same style as the Overview's zones table, or `empty` when there are no rows. */
export default function RowsTable({
  columns,
  rows,
  empty,
}: {
  columns: RowsTableColumn[]
  rows: React.ReactNode[][]
  empty: string
}) {
  return rows.length > 0 ? (
    <div className="overflow-x-auto">
      <table className="table table-xs w-full">
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c.header} className={`px-1 ${c.className ?? ''}`}>
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((cells, idx) => (
            <tr key={idx}>
              {cells.map((cell, cellIdx) => (
                <td key={cellIdx} className={`px-1 ${columns[cellIdx]?.className ?? ''}`}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="text-xs text-base-content/40">{empty}</div>
  )
}
